module.exports = __webpack_public_path__ + "static/media/500k.e6b1e081.png";